
export function saveForm<T = any>(name: string, values: T) {
  const valuesString = JSON.stringify(values);
  localStorage.setItem(name, valuesString);
}

export function restoreForm<T = any>(name: string, matcher: ((values: T) => boolean) | undefined = undefined, transformer: ((values: T) => T) | undefined = undefined): T | null {
  if (typeof localStorage === 'undefined') {
    return null;
  }

  const valuesString = localStorage.getItem(name);

  if (valuesString === null) {
    return null;
  }

  const values: T = JSON.parse(valuesString);

  let transformedValues = values;
  if (transformer && values !== null && typeof values === 'object' && !Array.isArray(values)) {
    transformedValues = transformer(values);
  }

  if (matcher) {
    const result = matcher(transformedValues);
    return result ? transformedValues : null;
  }

  return transformedValues;
}